import IAlert from "@/models/modelView/IAlert";
import geofencesModule from "@/store/modules/geofences.module";
import FormatDate from "@/utils/date.util";
import EventStrategy from "./event.strategy";

export default class GeofenceStrategy extends EventStrategy {

    mapEvent(): IAlert {
        return {
            data: [
                {
                    title: 'Fecha:',
                    value: FormatDate.getGenericFormat(this.event.eventTime) || ''
                },
                {
                    title: 'Geocerca:',
                    value: geofencesModule.geofences.find(geofence => geofence.id == this.event.geofenceId)?.name || ''
                }

            ],
            ...this.eventBase()
        }
    }

}